<template>
    <div class="logon_form">
        <LoginInput
            :placeholder="phonePlaceholder"
            suffix-icon="iconfont icon-dengluzhuce-zhanghao"
            v-model="value.phoneNumber"
            @input="handleInput"
            :disabled="disabledPhone">
        </LoginInput>
        <div class="rela">
            <LoginInput placeholder="验证码" width="220" v-model="value.smsVerifyCode"></LoginInput>
            <CodeButton
                class="get_verify_code"
                ref="countdown"
                :disabled="btnDisabled"
                :remember="remember"
                :sKey="formType"
                :start-count-down.sync="startCountDown"
                @smsBtnClick="showPictureAuthCode">
            </CodeButton>
        </div>
        <template v-if="!baseForm">
            <LoginInput
                placeholder="密码"
                type="password"
                tip="8-20位，需包含大小写字母和数字"
                v-model="value.password"
                @input="inputPwd">
            </LoginInput>
            <LoginInput
                placeholder="确认密码"
                type="password"
                v-model="value.confirmPassword"
                @input="inputConfirmPwd">
            </LoginInput>
            <div v-if="formType === 1">
                <el-checkbox v-model="isAllow">我已阅读并同意</el-checkbox>
                <a class="pro_btn" @click="showProtocol = true;">《梯之星广告开户协议》</a>
            </div>
        </template>
        <slot></slot>
        <el-dialog
            class="protocol_dialog"
            width="790px"
            title="梯之星传媒用户协议"
            :visible.sync="showProtocol"
            append-to-body
            close-on-click-modal
            @on-close="showProtocol = false">
            <div slot="title" class="pro_title">梯之星传媒用户协议</div>
            <div class="protocal" v-html="protocalStr"></div>
            <div slot="footer" class="pro_fot" @click.prevent="showProtocol = false;">确定</div>
        </el-dialog>
        <BaseFixCenter
            v-model="showPicAuth"
            title="请输入图片验证码"
            w="400"
            h="300"
            @close="clearCapAuth">
            <template #default>
                <div class="cap_auth_main">
                    <div class="pic_wrap">
                        <img class="pic_item" :src="picUrl" alt="图片验证码">
                        <div class="refresh_btn" @click="getCaptCha(true)">
                            <img class="refresh_pic" :src="refreshPic" alt="刷新图片验证码">
                        </div>
                    </div>
                    <el-input
                        :class="['cap_code_input', {'red': capCode.length}]"
                        v-model="capCode"
                        @keyup.enter.native="confirmCapCode">
                    </el-input>
                </div>
            </template>
            <template #footer>
                <div class="footer-button primary" @click="confirmCapCode">确定</div>
                <div class="footer-button" @click="clearCapAuth">取消</div>
            </template>
        </BaseFixCenter>
    </div>
</template>

<script type="text/javascript">
import LoginInput from '@/components/LoginInput'
import CodeButton from '@/components/TheCodeButton'
import { getVerifyCode } from '@/utils/customerApi'
import protocalStr from '@/utils/userProtocal'
import refreshPic from '@/assets/refresh_cap_code.png'

export default {
    name: 'LoginForm',
    components: { LoginInput, CodeButton },
    props: {
        value: {
            phoneNumber: '',
            smsVerifyCode: '',
            password: '',
            confirmPassword: ''
        },
        formType: {
            type: Number,
            default: 1 // 1:注册 2:忘记(重置)/修改密码 3:修改手机号 4:登录 5:设置/修改支付密码
        },
        remember: { // 是否开启验证码按钮倒计时记忆功能
            type: Boolean,
            default: false
        },
        baseForm: {
            type: Boolean,
            default: false
        },
        phonePlaceholder: {
            type: String,
            default: '手机号'
        },
        disabledPhone: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isAllow: false,
            startCountDown: false,
            protocalStr,
            showProtocol: false,
            showPicAuth: false, // 弹出图片验证码弹窗
            refreshPic,
            picUrl: '', // 图片验证码URL对象
            capCode: '',
            capCodeToken: '' // 图片验证码校验用token
        }
    },
    computed: {
        btnDisabled () {
            if (this.value.phoneNumber && this.value.phoneNumber.length === 11) {
                return false
            } else {
                return true
            }
        },
        adUser () {
            return this.$store.state.customer.userInfo
        },
    },
    watch: {
        adUser: {
            immediate: true,
            deep: true,
            handler (v) {
                if (!this.disabledPhone) return
                if (v && v.phone) this.value.phoneNumber = v.phone
            }
        },
        isAllow (nv) {
            let mark = !!nv
            for (let key in this.value) {
                mark = !!this.value[key] && mark
            }
            this.$emit('fn-handle', mark)
        },
        value: {
            deep: true,
            handler (nv) {
                let mark = true
                for (let key in nv) {
                    mark = !!nv[key] && mark
                }
                if (this.formType === 1) mark = !!this.isAllow && mark
                this.$emit('fn-handle', mark)
            }
        },
        phonePlaceholder (nv) {
            this.$refs.countdown.resetTime()
        },
    },
    methods: {
        async showPictureAuthCode () {
            await this.getCaptCha(false)
            this.showPicAuth = true
        },
        getCaptCha (isRefresh) { // 发送xhr获取图片验证码及token
            let load = this.$loading()
            return new Promise((resolve, reject) => {
                if (isRefresh) this.capCode = ''
                if (window.XMLHttpRequest) {
                    let xhr = new XMLHttpRequest()
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === 4) {
                            const status = xhr.status
                            let blobRes = xhr.response
                            if ((status >= 200 && status < 300) || status === 304) {
                                let tmpUrl = window.URL.createObjectURL(blobRes)
                                this.capCodeToken = xhr.getResponseHeader('token')
                                this.picUrl = tmpUrl
                                let to = setTimeout(() => {
                                    window.URL.revokeObjectURL(tmpUrl)
                                    clearTimeout(to)
                                }, 1000)
                                load.close()
                                resolve()
                            } else {
                                load.close()
                                console.warn(blobRes)
                                this.messageTip('图形验证码获取失败，请稍后再试')
                                reject(new Error('图形验证码获取失败，请稍后再试'))
                            }
                        }
                    }
                    xhr.open('GET', '/customer/api/v3/captcha', true)
                    xhr.responseType = 'blob'
                    xhr.timeout = 60000
                    xhr.send()
                } else {
                    load.close()
                    reject(new Error('此浏览器不支持xhr'))
                    console.warn('您的浏览器不支持XMLHttpRequest')
                }
            })
        },
        confirmCapCode () { // 图片验证码确认输入
            if (!this.capCode) return this.messageTip('请输入图片验证码')
            if (!this.capCodeToken) {
                console.warn('缺少图形验证码token')
                return
            }
            this.getVerificationCode()
        },
        clearCapAuth () { // 点击右上角/取消按钮及验证通过 关闭图形验证码弹窗时清空原有信息
            this.showPicAuth = false
            this.capCode = ''
            this.capCodeToken = ''
        },
        async getVerificationCode () { // 发送短信验证码之前需输入图片验证码
            let res = await getVerifyCode({
                captChaCode: this.capCode,
                phoneNumber: this.value.phoneNumber,
                token: this.capCodeToken,
                type: this.formType
            })
            if (res.code === 0) {
                this.clearCapAuth()
                this.$emit('smsSended')
                this.startCountDown = true
            } else { // 发生错误时由全局fetch进行错误提示(90001020:手机号已注册等)
                if (res.code === 900501) this.messageTip(res.message) // 图形验证码输入错误、验证码已失效
                tzx_czcPush('register', this.value.phoneNumber, 0)
            }
        },
        inputPwd (v) {
            this.$nextTick(() => {
                this.value.password = v.replace(/[^\da-zA-Z]/g, '')
            })
        },
        inputConfirmPwd (v) {
            this.$nextTick(() => {
                this.value.confirmPassword = v.replace(/[^\da-zA-Z]/g, '')
            })
        },
        handleInput (nv) {
            this.$nextTick(() => {
                this.value.phoneNumber = nv.replace(/\D+/g, '')
            })   
        }
    }
}
</script>

<style lang="scss" scoped>
.logon_form {
    .input_container {
        margin-top: 20px;
        margin-bottom: 30px;
        &:nth-child(4) {
            margin-bottom: 10px;
        }
    }
    .pro_btn {
        cursor: pointer;
    }
    .get_verify_code {
        position: absolute;
        top: 20px;
        right: 0;
    }
}
.cap_auth_main {
    background: #fff;
    height: 100%;
    padding: 34px 81px;
    .pic_wrap {
        background: #F5F5F5;
        border: 1px solid #D5D5D5;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        .pic_item {
            width: 160px;
            height: 50px;
            vertical-align: bottom;
        }
        .refresh_btn {
            cursor: pointer;
            width: 30px;
            height: 50px;
            margin-left: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            .refresh_pic {
                width: 21px;
                height: 21px;
                vertical-align: bottom;
            }
        }
    }
    .cap_code_input {
        border-bottom: 1px solid #282729;
        height: 50px;
        &.red {
            border-bottom: 1px solid $main-color;
        }
        ::v-deep .el-input__inner {
            border: none;
            color: #3B3F45;
            font-size: 24px;
            font-weight: 600;
            height: 100%;
            text-align: center;
            letter-spacing: 1em;
        }
    }
}
</style>

<style lang="sass">
.el-dialog__wrapper.protocol_dialog
    display: flex
    align-items: center
    justify-content: center
    > div
        border-radius: 4px
        margin: 0 auto
        margin-top: 100px !important
        height: 660px
        .el-dialog__header
            border-bottom: 1px solid #e9e9e9
            height: 50px
            line-height: 50px
            padding: 0
            text-align: center
            .pro_title
                height: 100%
                font-size: 18px
                font-weight: bold
            .el-dialog__headerbtn
                top: 15px
        .el-dialog__body
            height: 550px
            height: calc(100% - 110px)
            padding: 0
            .protocal
                height: 100%
                overflow: auto
                line-height: 1.8
                padding: 15px 50px 10px
                h3
                    text-indent: 1.5em
                .indent
                    font-weight: 600
                    text-indent: 2em
                .indent_light
                    text-indent: 2em
                .light
                    font-weight: 400
        .el-dialog__footer
            border-top: 1px solid #e9e9e9
            height: 60px
            padding: 0
            text-align: center
            .pro_fot
                border: 1px solid #d4d4d4
                border-radius: 4px
                cursor: pointer
                width: 120px
                height: 30px
                line-height: 30px
                margin: 14px auto 0
</style>
